module.exports = __webpack_public_path__ + "static/media/9DESA7.41e1025e.jpg";